import { render, staticRenderFns } from "./edit-appointment-old.vue?vue&type=template&id=8c28f954&scoped=true"
import script from "./edit-appointment-old.vue?vue&type=script&lang=js"
export * from "./edit-appointment-old.vue?vue&type=script&lang=js"
import style0 from "./edit-appointment-old.vue?vue&type=style&index=0&id=8c28f954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c28f954",
  null
  
)

export default component.exports